<template>
	<span class="drop-label-container" :class="dropClass"
		><span class="drop-label">{{ label }}</span
		><sym-icon v-if="!disabled" name="caret-right-14-bold"></sym-icon
	></span>
</template>

<script setup lang="ts">
import SymIcon from "./SymIcon.vue";
import {computed} from "vue";

const props = defineProps({
  label: String,
  open: Boolean,
  disabled: Boolean,
});

const dropClass = computed(() => {
  const c = [];
  if (props.disabled) c.push("drop-label-disabled");
  else if (props.open) c.push("drop-label-open");
  return c;
});

</script>

<style>
.drop-label-open > .drop-label {
	color: var(--active);
}
.drop-label-container > .fi {
	transition: 0.2s ease-out;
	margin-left: 8px;
	color: var(--active);
}
.drop-label-open > .fi {
	transform: rotate(90deg);
}
</style>
